/* Romaccio - uitschuifpaneel voor het hoofdmenu. Hoort bij
   snippets/ai-menupaneel.liquid en snippets/ai-css-menupaneel.liquid.

   Wat dit doet:
   - er is EEN paneel voor het hele menu. Wijs je Kleding, Jassen of Schoenen
     aan, dan opent datzelfde paneel en springt het naar die groep. Eerst had
     elke categorie zijn eigen paneel; dat voelde rommelig.
   - openen kan met een klik en, op een muis, ook door erover te gaan; dat
     laatste met een korte vertraging zodat het niet opent als je er alleen
     maar langs beweegt naar de winkelwagen
   - EENMAAL OPEN BLIJFT HET OPEN. Het valt alleen dicht als je ernaast klikt,
     op het kruisje klikt, Escape drukt, of de categorie nog eens aanklikt.
     Eerst ging het vanzelf dicht zodra je met de muis wegging; dan verdween
     het menu onder je handen terwijl je er nog naar keek.
   - items die in het paneel staan krijgen de klasse ai-mp-heeft, zodat de CSS
     er een pijltje bij kan zetten. Zonder dat pijltje zie je namelijk niet
     dat er iets achter zit - dat was precies de klacht.

   Het uitklapmenu van het thema wordt uitgezet via de markering ai-mp-aan op
   <html>, die hieronder gezet wordt. Draait dit script niet, dan staat die
   markering er niet en werkt het gewone uitklapmenu van het thema nog. De
   links zijn dus nooit onbereikbaar.

   Door Claude gebouwd, veilig te verwijderen. */
(function () {
  'use strict';

  var BREED = '(min-width: 750px)';
  var OPEN_NA = 220;   /* ms wachten voor hover opent */

  var huidige = null;      /* het paneel, als het open staat */
  var huidigeKnop = null;
  var viaHover = false;
  var openTimer = null;

  document.documentElement.classList.add('ai-mp-aan');

  function normaliseer(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  /* Het paneel staat in de footer-groep. Vast positioneren werkt daar, maar
     breekt zodra een voorouder ooit een transform krijgt. Daarom verhuizen we
     het een keer naar body. */
  function panelen() {
    var lijst = document.querySelectorAll('[data-ai-mp]');
    for (var i = 0; i < lijst.length; i++) {
      if (lijst[i].parentElement !== document.body) document.body.appendChild(lijst[i]);
    }
    return lijst;
  }

  function hetPaneel() {
    var lijst = panelen();
    return lijst.length ? lijst[0] : null;
  }

  /* De groep in het paneel die bij een menu-item hoort. Geen groep betekent:
     dit item hoort niet bij ons, laat het thema zijn werk doen. */
  function groepVoor(sleutel) {
    var p = hetPaneel();
    if (!p) return null;
    var g = p.querySelectorAll('[data-mp-groep]');
    for (var i = 0; i < g.length; i++) {
      if (g[i].getAttribute('data-mp-groep') === sleutel) return g[i];
    }
    return null;
  }

  /* Het menu-item in de header dat subitems heeft. Het thema rendert dat als
     een span met daarin een link en een knopje met pijltje; allebei horen ze
     hetzelfde paneel te openen. */
  function trigger(el) {
    if (!el || !el.closest) return null;
    var item = el.closest('.menu-list__list-item');
    if (!item) return null;
    if (item.getAttribute('slot') === 'more') return null;   /* het overloopmenu laten we met rust */
    if (!item.querySelector('.menu-list__disclosure')) return null;
    return item;
  }

  function sleutelVan(item) {
    var a = item.querySelector('a, button');
    return normaliseer(a ? a.textContent : item.textContent);
  }

  /* Items die in het paneel staan merken, zodat de CSS er een pijltje bij zet. */
  function markeer() {
    var items = document.querySelectorAll('.menu-list__list-item');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.getAttribute('slot') === 'more') continue;
      if (!item.querySelector('.menu-list__disclosure')) continue;
      if (groepVoor(sleutelVan(item))) item.classList.add('ai-mp-heeft');
    }
  }

  /* Het paneel onder de koptekst laten beginnen, zodat die zichtbaar blijft en
     je met de muis van Kleding naar Jassen kunt. Een vaste waarde zou op de
     ene pagina te hoog en op de andere te laag staan, dus meten we het. */
  function zetBovenkant() {
    var kop = document.querySelector('#header-component');
    var onder = kop ? Math.max(0, Math.round(kop.getBoundingClientRect().bottom)) : 0;
    document.documentElement.style.setProperty('--mp-top', onder + 'px');
  }

  /* De aangewezen groep onderstrepen en in beeld brengen. Scrollen doen we met
     scrollTop en niet met scrollIntoView: dat laatste sleept ook de pagina
     erachter mee. */
  function zetActief(p, groep) {
    var alle = p.querySelectorAll('.ai-mp__groep');
    for (var i = 0; i < alle.length; i++) {
      if (alle[i] === groep) alle[i].classList.add('is-actief');
      else alle[i].classList.remove('is-actief');
    }
    var vak = p.querySelector('.ai-mp__inhoud');
    if (vak && groep) vak.scrollTop = Math.max(0, groep.offsetTop - vak.offsetTop - 6);
  }

  function stopTimers() {
    if (openTimer) { clearTimeout(openTimer); openTimer = null; }
  }

  function sluit() {
    stopTimers();
    if (!huidige) return;
    var p = huidige;
    p.classList.remove('is-open');
    document.body.classList.remove('ai-mp-open');
    setTimeout(function () {
      if (!p.classList.contains('is-open')) {
        p.hidden = true;
        var alle = p.querySelectorAll('.ai-mp__groep');
        for (var i = 0; i < alle.length; i++) alle[i].classList.remove('is-actief');
      }
    }, 320);
    if (huidigeKnop) {
      huidigeKnop.classList.remove('ai-mp-open-item');
      if (!viaHover && document.body.contains(huidigeKnop)) {
        var f = huidigeKnop.querySelector('a, button');
        if (f) f.focus();
      }
    }
    huidige = null;
    huidigeKnop = null;
    viaHover = false;
  }

  function open(item, doorHover) {
    var p = hetPaneel();
    var groep = groepVoor(sleutelVan(item));
    if (!p || !groep) return;
    stopTimers();
    zetBovenkant();

    /* Van categorie wisselen laat het paneel staan; alleen de groep verschuift. */
    var stond_al_open = huidige === p;
    if (huidigeKnop && huidigeKnop !== item) huidigeKnop.classList.remove('ai-mp-open-item');

    huidige = p;
    huidigeKnop = item;
    viaHover = !!doorHover;
    item.classList.add('ai-mp-open-item');

    if (!stond_al_open) {
      p.hidden = false;
      document.body.classList.add('ai-mp-open');
      /* De browser moet de beginstand (paneel links buiten beeld) berekend
         hebben voor we is-open zetten, anders springt het paneel er zonder
         animatie in. offsetWidth opvragen dwingt die berekening af. Dat is
         betrouwbaarder dan requestAnimationFrame, want dat vuurt niet in een
         tabblad op de achtergrond. */
      void p.offsetWidth;
      p.classList.add('is-open');
    }

    zetActief(p, groep);

    if (!doorHover && !stond_al_open) {
      setTimeout(function () {
        var k = p.querySelector('.ai-mp__sluit');
        if (k) k.focus();
      }, 60);
    }
  }

  function breed() {
    return window.matchMedia(BREED).matches;
  }

  /* Klikken: werkt altijd, ook op een telefoon en met het toetsenbord. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-ai-mp-sluit]')) {
      e.preventDefault();
      sluit();
      return;
    }

    /* Binnen het paneel gewoon doorklikken naar de collectie. */
    if (t.closest('.ai-mp__paneel')) return;

    /* Ernaast klikken sluit het. Het donkere scherm ligt over alles onder de
       koptekst, dus dit vangt ook een klik op de pagina erachter. De koptekst
       zelf niet: daar zitten de categorieen waar je naartoe wilt wisselen. */
    if (huidige && !t.closest('#header-component')) {
      sluit();
      return;
    }

    var item = trigger(t);
    if (item && groepVoor(sleutelVan(item))) {
      e.preventDefault();
      e.stopPropagation();
      if (huidige && huidigeKnop === item) sluit();
      else open(item, false);
    }
  }, true);

  /* Hoveren: alleen met een muis en alleen op een breed scherm. Hoveren opent,
     maar sluit NOOIT - ga je met de muis weg, dan blijft het paneel gewoon
     staan tot je ergens klikt. */
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch' || !breed()) return;

    var item = trigger(e.target);
    if (item && groepVoor(sleutelVan(item))) {
      if (huidige && huidigeKnop === item) return;
      if (openTimer) clearTimeout(openTimer);
      /* Staat het paneel al open, dan hoeft de wisseling niet te wachten. */
      if (huidige) { open(item, true); return; }
      openTimer = setTimeout(function () { openTimer = null; open(item, true); }, OPEN_NA);
      return;
    }

    /* Buiten een menu-item: een geplande opening vervalt. Een paneel dat al
       open staat laten we met rust. */
    if (openTimer) { clearTimeout(openTimer); openTimer = null; }
  });

  /* Escape sluit. Dit moet in de vangfase: het thema vangt Escape zelf af voor
     zijn eigen lades en houdt de toets tegen voor hij bij ons is. */
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && huidige) sluit();
  }, true);

  /* Navigeren met de browserknoppen mag het paneel niet open laten staan. */
  window.addEventListener('pageshow', sluit);

  function start() {
    panelen();
    markeer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* De header wordt opnieuw getekend bij een plakkende kop of een sectiewissel
     in de thema-editor; dan moeten de pijltjes er opnieuw bij. */
  new MutationObserver(markeer).observe(document.documentElement, { childList: true, subtree: true });
})();
